import React from "react";
import { Outlet } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import Loading from "../components/Loading";
import { loadingState } from "../recoil/atoms/loading";
import { useRecoilValue } from "recoil";


export default function Root(){

    const loading = useRecoilValue(loadingState);
    
    return(
        <div className="mWrap"> 
            <Outlet />
            <BottomNav />
            {loading && <Loading />}
        </div>
    );
};